// extracted by mini-css-extract-plugin
export var active = "_f8-c";
export var compactArrow = "_f8-5";
export var container = "_f8-0";
export var dot = "_f8-b";
export var dotContainer = "_f8-a";
export var hoverArrowButton = "_f8-7";
export var hoverArrowContainer = "_f8-6";
export var leftHoverArrowContainer = "_f8-8 _f8-6";
export var rightHoverArrowContainer = "_f8-9 _f8-6";
export var slide = "_f8-4";
export var sliderContainer = "_f8-1";
export var sliderContainerVisibleOverflow = "_f8-2";
export var sliderOverflow = "_f8-3";
export var vignetteBoth = "_f8-f";
export var vignetteLeft = "_f8-e";
export var vignetteRight = "_f8-d";